const joinPaths = (base, path) => {
  if (!base) return '';
  const normalizedBase = base.replace(/\/$/, '');
  const normalizedPath = path.replace(/^\//, '');
  return `${normalizedBase}/${normalizedPath}`;
};

const deriveBaseFromVerifyEndpoint = (verifyEndpoint) => {
  const trimmed = (verifyEndpoint || '').trim();
  if (!trimmed) return '';

  try {
    const url = new URL(trimmed);
    const segments = url.pathname.split('/').filter(Boolean);
    if (segments.length) {
      segments.pop();
      url.pathname = segments.length ? `/${segments.join('/')}` : '/';
    }
    const toString = url.toString();
    return toString.replace(/\/$/, '');
  } catch (err) {
    return trimmed.replace(/\/?[^/]*$/, '');
  }
};

const normalizePath = (value) => {
  if (!value) return '/password-reset';
  try {
    const url = new URL(value, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    return url.pathname || '/password-reset';
  } catch (err) {
    if (value.startsWith('/')) return value || '/password-reset';
    return `/${value}`;
  }
};

export const getVerificationServiceConfig = () => {
  const verifyEndpoint = (process.env.REACT_APP_VERIFY_ENDPOINT || '').trim();
  const explicitResetRequest = (process.env.REACT_APP_PASSWORD_RESET_REQUEST_ENDPOINT || '').trim();
  const explicitPasswordReset = (process.env.REACT_APP_PASSWORD_RESET_ENDPOINT || '').trim();
  const explicitDefaultSuccess = (process.env.REACT_APP_DEFAULT_SUCCESS_REDIRECT || '').trim();

  const base = deriveBaseFromVerifyEndpoint(verifyEndpoint);

  const resetRequestEndpoint = explicitResetRequest || joinPaths(base, '/password-reset-requests');
  const passwordResetEndpoint = explicitPasswordReset || joinPaths(base, '/password-resets');

  const defaultRedirectPath = normalizePath(explicitDefaultSuccess || '/password-reset');

  const defaultRedirectUrl = (() => {
    if (explicitDefaultSuccess) return explicitDefaultSuccess;
    if (typeof window !== 'undefined' && window.location?.origin) {
      return `${window.location.origin}${defaultRedirectPath}`;
    }
    return defaultRedirectPath;
  })();

  return {
    verifyEndpoint,
    base,
    resetRequestEndpoint,
    passwordResetEndpoint,
    defaultRedirectUrl,
    defaultRedirectPath,
  };
};

export default getVerificationServiceConfig;
